import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {css} from "@emotion/css";
import React, {useEffect, useState} from "react";
import {MagazineService} from "../../serverService/magazineService/MagazineService";
import {convertUniversalDateTimeToPersianDateTime} from "../../util/DateConvertor";
import MagazineAddItem from "../../component/magazine/magazineAddItem/MagazineAddItem";
import {useNavigate} from "react-router-dom";
import ThumborHelper from "../../util/ThumborHelper";
import thumbnail from "../../assets/images/placeholder/Group 1000003894 1.svg"
import {
    showServerErrorMessage,
    RaikoCustomSimpleActiveDeActiveChip,
    RaikoDefaultDialogPage,
    DialogSize,
    RaikoBaseContainer,
    RaikoGridOneColumn,
    RaikoBreadcrumb,
    RaikoTableTitleContainer,
    raikoBreadCrumbItemGenerator, RaikoBaseCardContainer, RaikoCustomTable,
    prepareRaikoSelectBoxItem, RaikoSelectBox
} from "@moeindal/base-raiko-panel-components";

export default function MagazineList() {

    const service = new MagazineService()

    let page = 0
    const size = 15

    const [availableCategory, setAvailableCategory] = useState(
        [
            prepareRaikoSelectBoxItem(magazineTypes.NEWS.id, magazineTypes.NEWS.title, magazineTypes.NEWS.icon),
            prepareRaikoSelectBoxItem(magazineTypes.VIDEO.id, magazineTypes.VIDEO.title, magazineTypes.VIDEO.icon),
            prepareRaikoSelectBoxItem(magazineTypes.PODCAST.id, magazineTypes.PODCAST.title, magazineTypes.PODCAST.icon),
            prepareRaikoSelectBoxItem(magazineTypes.PHOTO_GALLERY.id, magazineTypes.PHOTO_GALLERY.title, magazineTypes.PHOTO_GALLERY.icon),
        ]
    );
    const [selectedCategory, setSelectedCategory] = useState(magazineTypes.NEWS.id);
    const [categoryShimmer, setCategoryShimmer] = useState(false);

    function handleChangeCategory(newSelectedCategory) {
        setSelectedCategory(newSelectedCategory)
    }


    const [magazineData, setMagazineData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [tableListShimmerState, setTableListShimmerState] = useState(false);

    function handlePagination(newPage) {
        page = newPage
        getDataFromServer()
    }

    useEffect(() => {
        getDataFromServer()
    }, [selectedCategory]);

    function getDataFromServer() {
        setTableListShimmerState(true)
        service.getMagazineItemsList(
            page,
            size,
            selectedCategory)
            .then(response => {
                setPageCount(response.totalPage)
                setTotalItems(response.numberOfItems)

                setMagazineData([])
                response.data.map((item, index) => {
                    setMagazineData(prevState => [
                        ...prevState,
                        prepareTableItem(item, index)
                    ])
                })


            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setTableListShimmerState(false)
        })
    }

    function prepareTableItem(item, index) {
        return {
            number: (page * size) + index + 1,
            "id": item.id,
            "title": item.title,
            "createdBy": item.createdBy,
            "published": <RaikoCustomSimpleActiveDeActiveChip
                deActiveStateTitle={"غیر فعال"}
                activeStateTitle={"فعال"}
                state={item.published}
            />,
            "publishedAt": item.publishedAt ? convertUniversalDateTimeToPersianDateTime(item.publishedAt) : "-",
            "type": magazineTypes[item.type].title,
            "createdAt": item.createdAt ? convertUniversalDateTimeToPersianDateTime(item.createdAt) : "-",
            "thumbnail": item.thumbnail && item.thumbnail.downloadUrl ?
                <img
                    src={new
                    ThumborHelper.Builder(item.thumbnail.downloadUrl)
                        .setImageCompressSize(50, 50)
                        .changeQuality(10)
                        .convertWebp()
                        .build()
                    }
                    className={css`
                        width: 50px;
                        height: 50px;
                        aspect-ratio: 1/1;
                        border-radius: 8px;
                        background: var(--header-border-bottom-color)`
                    }
                    alt=""/>
                : <img
                    src={thumbnail}
                    className={css`
                        border-radius: 8px;
                        width: 50px;
                        height: 50px;
                        aspect-ratio: 1/1;
                        object-fit: cover;
                    `
                    }
                    alt=""/>
        }
    }

    const navigate = useNavigate()

    function handleSelectRow(_item) {
        let _title = ""
        magazineData.map((item) => {
            if (item.id === _item)
                _title = item.title
        })

        navigate(
            RouteHelper.MagazineDetail.globalUrl.replace(":id", _item),
            {state: {title: _title}, replace: false}
        )
    }


    const [dialogState, setDialogState] = useState(false);

    function handleAddNewItemToTable(newItem) {
        const _list = []
        _list.push(prepareTableItem(newItem, 0))
        magazineData.map((item, index) => {
            _list.push({
                ...item,
                number: (page * size) + index + 2,
            })
        })

        setMagazineData(_list)
        setDialogState(false)
    }


    return (
        <>
            <RaikoDefaultDialogPage
                onClose={_ => setDialogState(false)}
                open={dialogState}
                pageTitle={""}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <MagazineAddItem handleAddNewItem={handleAddNewItemToTable}/>
            </RaikoDefaultDialogPage>


            <Helmet>
                <title>{RouteHelper.MagazineList.name}</title>
            </Helmet>
            <RaikoBaseContainer>
                <RaikoGridOneColumn>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.MagazineList.name,
                            RouteHelper.MagazineList.globalUrl,
                        ),
                        raikoBreadCrumbItemGenerator(
                            magazineTypes[selectedCategory].title,
                            "",
                        ),
                    ]}/>

                    <RaikoSelectBox
                        changeSelectItem={handleChangeCategory}
                        items={availableCategory}
                        loading={categoryShimmer}
                        defaultSelectedItem={selectedCategory}
                    />

                    <RaikoBaseCardContainer>
                        <RaikoGridOneColumn>
                            <RaikoTableTitleContainer
                                title={"آخرین مقالات"}
                                hasCreateNewItem
                                handleCreateNewItem={_ => setDialogState(true)}
                                amount={totalItems}
                            />
                            <RaikoCustomTable
                                isLoading={tableListShimmerState}
                                data={magazineData}
                                header={tableHeader}
                                handlePaginationChange={handlePagination}
                                pageCount={pageCount}
                                rowClicked={handleSelectRow}
                            />
                        </RaikoGridOneColumn>
                    </RaikoBaseCardContainer>
                </RaikoGridOneColumn>
            </RaikoBaseContainer>

        </>
    )
}


const tableHeader = [
    {
        id: "number",
        label: "#"
    }, {
        id: "thumbnail",
        label: "تصویر شاخص"
    }, {
        id: "title",
        label: "عنوان"
    }, {
        id: "type",
        label: "دسته بندی"
    }, {
        id: "createdBy",
        label: "سازنده"
    }, {
        id: "createdAt",
        label: "تاریخ ساخت"
    }, {
        id: "published",
        label: "وضعیت انتشار"
    }, {
        id: "publishedAt",
        label: "تاریخ انتشار"
    },
]

export const magazineTypes = {
    "NEWS": {
        id: "NEWS",
        title: "اخبار",
        icon: "ic-news-post"
    },
    "VIDEO": {
        id: "VIDEO",
        title: "فیلم",
        icon: "ic-video-post"
    },
    "PODCAST": {
        id: "PODCAST",
        title: "پادکست",
        icon: "ic-podcast-post"
    },
    "PHOTO_GALLERY": {
        id: "PHOTO_GALLERY",
        title: "گالری تصاویر",
        icon: "ic-slider-post"
    },
}

